export default {
  paged: {
    select:
      'id,name,description,isActive,shortCode,isPublic,permissionsFiltersLogicalOperator,hideMenuItemHome,hideMenuItemTasks,hideMenuItemRequests',
    searchSelect: ['name', 'description', 'shortCode'],
    notSelectSearch: 'shortenedUrl',
    expand: {
      shortenedUrl: {
        select: 'shortenedUrlCode,redirectUrl',
      },
    },
    orderBy: 'name',
  },
  item: {
    select:
      'id,name,description,isActive,shortCode,shortenedUrlId,template,logoUrl,iconLogoUrl,faviconUrl,mainColor,fontUrl,loginSplashUrl,isPublic,permissionsFiltersLogicalOperator,hideMenuItemHome,hideMenuItemTasks,hideMenuItemRequests',
    expand: {
      shortenedUrl: {
        select: 'shortenedUrlCode,redirectUrl',
      },
    },
  },
  itemDetail: {
    select:
      'id,name,description,isActive,shortCode,shortenedUrlId,template,logoUrl,iconLogoUrl,faviconUrl,mainColor,fontUrl,loginSplashUrl,isPublic,permissionsFiltersLogicalOperator,hideMenuItemHome,hideMenuItemTasks,hideMenuItemRequests,created,updated',
    expand: {
      shortenedUrl: {
        select: 'shortenedUrlCode,redirectUrl',
      },
      userCreator: { select: 'id,fullName' },
      userModifier: { select: 'id,fullName' },
    },
  },
};
